<template>
  <div class="card-body">
    <h4 id="header-other" class="card-title card-collapse ">
      <!-- 10.แก้ไขส่วนของ other setting เปลี่ยนเป็น other   -->
      <span class="pointer" @click="onClickCollapse">Other</span>

      <!-- <span class="f-10 ml-2">Description Lorem Ipsom</span> -->
      <span class="f-10 ml-2">
        <b-icon
          icon="exclamation-circle-fill"
          variant="danger"
          animation="throb"
          font-scale="2"
          v-if="otherComponentModel.validateState == false"
          @click="
            otherComponentModel.collapseState =
              !otherComponentModel.collapseState
          "
        ></b-icon>
      </span>
      <span class="icon-collapse">
        <button class="btn-icon-collapse" @click="onClickCollapse">
          <template>
            <i
              v-if="otherComponentModel.collapseState"
              class="dripicons-minus"
            />
            <i v-else class="dripicons-plus" />
          </template>
        </button>
      </span>
    </h4>
    <b-collapse
      id="collapse-other"
      v-model="otherComponentModel.collapseState"
      @input="modelChanged"
    >
      <validationObserver ref="componentForm" tag="form">
        <div class="pt-3">
          <div class="row">
            <div class="col-12">
              <div class="border-top pb-4"></div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div
                v-if="
                  userInfo.user_type === 'Operator' ||
                  (userInfo.user_type === 'Vendor' &&
                    vendor_type === 'OFMStock')
                "
                class="form-row form-group"
              >
                <label class="col-lg-4 col-xl-3 col-form-label"
                  >ประเภทสินค้า</label
                >
                <div class="col-sm-9 col-form-label">
                  <b-form-radio-group
                    :disabled="
                      is_consignment ||
                      dataPermissions.find((f) => f.name === 'other')
                        .isEditable === false
                    "
                    v-model="otherComponentModel.model.is_consignment"
                  >
                    <b-form-radio :value="false" class="w-120-px"
                      >Credit Item</b-form-radio
                    >
                    <b-form-radio :value="true" class="w-120-px"
                      >Consignment</b-form-radio
                    >
                  </b-form-radio-group>
                </div>
              </div>
              <div
                v-if="userInfo.user_type === 'Operator'"
                class="form-row form-group"
              >
                <label class="col-lg-4 col-xl-3 col-form-label"
                  >ค่าธรรมเนียมผลิตภัณฑ์ใหม่</label
                >
                <div class="col-sm-9 col-form-label">
                  <b-form-radio-group
                    v-model="otherComponentModel.model.has_new_product_fee"
                    :disabled="
                      dataPermissions.find((f) => f.name === 'other')
                        .isEditable === false
                    "
                  >
                    <b-form-radio :value="true" class="w-120-px"
                      >มีค่าธรรมเนียม</b-form-radio
                    >
                    <b-form-radio :value="false" class="w-120-px"
                      >ไม่มีค่าธรรมเนียม</b-form-radio
                    >
                  </b-form-radio-group>
                </div>
              </div>
              <div class="form-row form-group">
                <label class="col-lg-4 col-xl-3 col-form-label"
                  >การคืนสินค้า</label
                >
                <div class="col-sm-9 col-form-label">
                  <b-form-radio-group
                    v-model="otherComponentModel.model.is_return_to_vendor"
                    :disabled="
                      dataPermissions.find((f) => f.name === 'other')
                        .isEditable === false
                    "
                  >
                    <b-form-radio :value="true" class="w-120-px"
                      >คืนได้</b-form-radio
                    >
                    <b-form-radio :value="false" class="w-120-px"
                      >คืนไม่ได้</b-form-radio
                    >
                  </b-form-radio-group>
                </div>
              </div>
              <div
                class="form-row form-group"
                v-if="otherComponentModel.model.is_return_to_vendor === true"
              >
                <label class="col-lg-4 col-xl-3 col-form-label" for="aging"
                  >ระยะเวลารับคืนสินค้า</label
                >
                <div class="col-sm-4">
                  <multiselect
                    v-model="otherComponentModel.model.aging"
                    :internalSearch="false"
                    :options="options_options_aging"
                    :allowEmpty="false"
                    :custom-label="
                      (label) => (label === '0' ? 'ไม่ระบุ' : label)
                    "
                    :show-labels="false"
                    :disabled="
                      dataPermissions.find((f) => f.name === 'other')
                        .isEditable === false
                    "
                  />
                </div>
              </div>
              <div
                v-if="userInfo.user_type === 'Operator'"
                class="form-row form-group"
              >
                <label
                  class="col-lg-4 col-xl-3 col-form-label"
                  for="otherSettingType"
                  >ชนิดสินค้า</label
                >
                <div class="col-sm-4">
                  <validationProvider
                    v-slot="{ errors }"
                    name="otherSettingType"
                    :rules="{ dynamicRequired: ['กรุณาเลือกชนิดสินค้า'] }"
                  >
                    <multiselect
                      v-model="otherComponentModel.model.type"
                      :options="options_vendor_type"
                      :internalSearch="false"
                      :class="{
                        'is-invalid':
                          errors &&
                          errors.length &&
                          !otherComponentModel.model.type,
                      }"
                      :allowEmpty="false"
                      :show-labels="false"
                      placeholder="กรุณาเลือกชนิดสินค้า"
                      :disabled="
                        dataPermissions.find((f) => f.name === 'other')
                          .isEditable === false
                      "
                    />
                    <span
                      v-if="
                        errors &&
                        errors.length &&
                        !otherComponentModel.model.type
                      "
                      class="validate-invalid"
                    >
                      {{ errors[0] }}
                    </span>
                  </validationProvider>
                </div>
              </div>
              <div
                v-if="userInfo.user_type === 'Operator'"
                class="form-row form-group"
              >
                <label class="col-lg-4 col-xl-3 col-form-label"
                  >สินค้า Own Brand</label
                >
                <div class="col-sm-9 col-form-label">
                  <switches
                    v-model="otherComponentModel.model.is_own_brand"
                    type-bold="true"
                    color="info"
                    class="switch-inner-label custom-switches switches-small switches-margin-top"
                    text-enabled="Yes"
                    text-disabled="No"
                    :disabled="true"
                  ></switches>
                </div>
              </div>
              <div class="form-row form-group">
                <label class="col-lg-4 col-xl-3 col-form-label"
                  >สินค้านำเข้า</label
                >
                <div class="col-sm-9 col-form-label">
                  <switches
                    v-model="otherComponentModel.model.is_import"
                    type-bold="true"
                    color="info"
                    class="switch-inner-label custom-switches switches-small switches-margin-top"
                    text-enabled="Yes"
                    text-disabled="No"
                    :disabled="
                      dataPermissions.find((f) => f.name === 'other')
                        .isEditable === false
                    "
                  ></switches>
                </div>
              </div>
              <!-- ส่วน Other Setting จะปิดการแสดงข้อมูล “สินค้า Free” และ “สินค้า PreOrder” ออกไป เนื่องจากสามารถดูจาก Status สินค้าได้เลย
              <div
                v-if="
                  userInfo.user_type === 'Operator' ||
                  (userInfo.user_type === 'Vendor' &&
                    vendor_type === 'OFMStock')
                "
                class="form-row form-group"
              >
                <label class="col-lg-4 col-xl-3 col-form-label"
                  >สินค้า PreOrder</label
                >
                <div class="col-sm-9 col-form-label">
                  <switches
                    v-model="otherComponentModel.model.is_preorder"
                    type-bold="true"
                    color="info"
                    class="switch-inner-label custom-switches switches-small switches-margin-top"
                    text-enabled="Yes"
                    text-disabled="No"
                    :disabled="
                      dataPermissions.find((f) => f.name === 'other')
                        .isEditable === false
                    "
                  ></switches>
                </div>
              </div> -->
              <div
                v-if="userInfo.user_type === 'Operator'"
                class="form-row form-group"
              >
                <label class="col-lg-4 col-xl-3 col-form-label"
                  >สินค้าราคาประมูล</label
                >
                <div class="col-sm-9 col-form-label">
                  <switches
                    v-model="otherComponentModel.model.is_bidding_price"
                    type-bold="true"
                    color="info"
                    class="switch-inner-label custom-switches switches-small switches-margin-top"
                    text-enabled="Yes"
                    text-disabled="No"
                    :disabled="
                      dataPermissions.find((f) => f.name === 'other')
                        .isEditable === false
                    "
                  ></switches>
                </div>
              </div>
              <!-- ส่วน Other Setting จะปิดการแสดงข้อมูล “สินค้า Free” และ “สินค้า PreOrder” ออกไป เนื่องจากสามารถดูจาก Status สินค้าได้เลย -->
              <!-- <div
                v-if="userInfo.user_type === 'Operator'"
                class="form-row form-group"
              >
                <label class="col-lg-4 col-xl-3 col-form-label"
                  >สินค้าฟรี</label
                >
                <div class="col-sm-9 col-form-label">
                  <switches
                    v-model="otherComponentModel.model.is_free"
                    type-bold="true"
                    color="info"
                    class="switch-inner-label custom-switches switches-small switches-margin-top"
                    text-enabled="Yes"
                    text-disabled="No"
                    :disabled="true"
                  ></switches>
                </div>
              </div> -->
              <div
                v-if="userInfo.user_type === 'Operator'"
                class="form-row form-group"
              >
                <label class="col-lg-4 col-xl-3 col-form-label"
                  >สินค้ากระเช้าต้องแยกจัดส่ง</label
                >
                <div class="col-sm-9 col-form-label">
                  <switches
                    v-model="otherComponentModel.model.is_hamper"
                    type-bold="true"
                    color="info"
                    class="switch-inner-label custom-switches switches-small switches-margin-top"
                    text-enabled="Yes"
                    text-disabled="No"
                    :disabled="
                      dataPermissions.find((f) => f.name === 'other')
                        .isEditable === false
                    "
                  ></switches>
                </div>
              </div>
              <div
                v-if="userInfo.user_type === 'Operator'"
                class="form-row form-group"
              >
                <label class="col-lg-4 col-xl-3 col-form-label"
                  >สินค้ามี สคบ.</label
                >
                <div class="col-sm-9 col-form-label">
                  <switches
                    v-model="otherComponentModel.model.has_consumer_protection"
                    type-bold="true"
                    color="info"
                    class="switch-inner-label custom-switches switches-small switches-margin-top"
                    text-enabled="Yes"
                    text-disabled="No"
                    :disabled="
                      dataPermissions.find((f) => f.name === 'other')
                        .isEditable === false
                    "
                  ></switches>
                </div>
              </div>
              <div
                v-if="
                  userInfo.user_type === 'Operator' &&
                  vendor_type === 'OFMStock' &&
                  (product_status === 'PreOrder' ||
                    product_status === 'NonStock')
                "
                class="form-row form-group"
              >
                <label class="col-lg-4 col-xl-3 col-form-label"
                  >สินค้ามีการกำหนด stock เสมือน</label
                >
                <div class="col-sm-9 col-form-label">
                  <switches
                    v-model="otherComponentModel.model.is_virtual_stock"
                    type-bold="true"
                    color="info"
                    class="switch-inner-label custom-switches switches-small switches-margin-top"
                    text-enabled="Yes"
                    text-disabled="No"
                    :disabled="
                      dataPermissions.find((f) => f.name === 'other')
                        .isEditable === false
                    "
                  ></switches>
                </div>
              </div>
              <div
                class="form-row mb-3"
                v-if="
                  product_status &&
                  product_status === 'PreOrder' &&
                  vendor_type &&
                  vendor_type === 'OFMStock'
                "
              >
                <label class="col-lg-4 col-xl-3 col-form-label"
                  >วันที่เริ่ม Pre-Order</label
                >
                <div class="col-sm-4">
                  <validationProvider
                    v-slot="{ errors }"
                    name="pre_order_start_date"
                    :rules="{
                      dynamicRequired2: [
                        error_start_date != '',
                        error_start_date,
                      ],
                    }"
                    class="relative d-block form-group inline-icon"
                  >
                      <date-picker
                        placeholder="เลือกวันที่"
                        v-model="date_start"
                        :type="'date'"
                        lang="en"
                        :format="'DD/MM/YYYY'"
                        confirm
                        :class="{ 'is-invalid': errors.length }"
                        @change="onSelectDate(date_start, true)"
                        :disabled="
                          dataPermissions.find((f) => f.name === 'other')
                            .isEditable === false
                        "
                      />
                    <span
                      v-if="error_start_date.length"
                      class="validate-invalid"
                      style="bottom: 0px !important"
                    >
                      {{ error_start_date }}
                    </span>
                  </validationProvider>
                </div>
              </div>
              <div
                class="form-row mb-3"
                v-if="
                  product_status &&
                  product_status === 'PreOrder' &&
                  vendor_type &&
                  vendor_type === 'OFMStock'
                "
              >
                <label class="col-lg-4 col-xl-3 col-form-label"
                  >วันที่สิ้นสุด Pre-Order</label
                >
                <div class="col-sm-4">
                  <validationProvider
                    v-slot="{ errors }"
                    name="pre_order_end_date"
                    :rules="{
                      dynamicRequired2: [error_end_date != '', error_end_date],
                    }"
                    class="relative d-block form-group inline-icon"
                  >
                      <date-picker
                        placeholder="เลือกวันที่"
                        v-model="date_end"
                        :type="'date'"
                        lang="en"
                        :format="'DD/MM/YYYY'"
                        confirm
                        :class="{ 'is-invalid': errors.length }"
                        @change="onSelectDate(date_end, false)"
                        :disabled="
                          dataPermissions.find((f) => f.name === 'other')
                            .isEditable === false
                        "
                      />
                    <span
                      v-if="error_end_date.length"
                      class="validate-invalid"
                      style="bottom: 0px !important"
                    >
                      {{ error_end_date }}
                    </span>
                  </validationProvider>
                </div>
              </div>
              <div class="form-row form-group">
                <label
                  class="col-lg-4 col-xl-3 col-form-label"
                  for="vendor_remark"
                  >หมายเหตุสินค้าจาก Vendor</label
                >
                <div class="col-sm-9">
                  <textarea
                    rows="4"
                    id="vendor_remark"
                    name="vendor_remark"
                    type="text"
                    class="form-control"
                    v-model="otherComponentModel.model.vendor_remark"
                    :disabled="
                      userInfo.user_type === 'Operator' ||
                      dataPermissions.find((f) => f.name === 'other')
                        .isEditable === false
                    "
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </validationObserver>
    </b-collapse>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import Switches from 'vue-switches'
import { TypeEnum } from '@/enum/vendor.enum.js'
import { eventBus } from '@/main.js'
import { getUserInfo } from '@/helpers/utils/jwt'
import { authComputed } from '@/state/helpers'
import brandService from '@/helpers/service/brand-service'
import DatePicker from 'vue2-datepicker'
import { ToISOString } from '@/helpers/utils/format-date.js'
export default {
  name: 'Other',
  components: { Multiselect, Switches, DatePicker },
  props: {
    skus: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      default: () => {
        return this.otherComponentModel
      },
    },
    vendor_type: {
      type: String,
      default: () => {
        return ''
      },
    },
    is_consignment: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    is_import: {
      type: Boolean,
      default: () => {
        return true
      },
    },
    is_free: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    brand_id: {
      type: String,
      default: () => {
        return ''
      },
    },
    requestDocumentInformation: {
      type: Object,
      default: () => {
        return null
      },
    },
    is_view: {
      type: Boolean,
      default: () => {
        return false
      },
    },
  },
  data() {
    return {
      options_aging: ['0', '90', '120', '360'],
      options_type: [
        'Book',
        'Computer',
        'Furniture',
        'Ink',
        'Office Automation',
        'MARKET PLACE',
      ],
      otherComponentModel: {
        collapseState: false,
        validateState: false,
        isPayloadChanged: false,
        model: {
          is_consignment: false,
          has_new_product_fee: false,
          is_return_to_vendor: true,
          aging: 0,
          is_import: true,
          is_own_brand: true,
          is_bidding_price: false,
          is_preorder: false,
          is_available_stock: true,
          is_free: true,
          type: '',
          is_hamper: false,
          has_consumer_protection: true,
          vendor_remark: '',
          product_remark: '',
          is_delivery_restriction: false,
          pre_order_start_date: '',
          pre_order_end_date: '',
        },
      },
      isError: false,
      isReload: false,
      permissions: [
        {
          name: 'other',
          ruleIDs: ['P1', 'P2', 'P3', 'P6', 'P7', 'P8'],
          isEditable: false,
        },
      ],
      isFirstLoadBand: true,
      product_status: '',
      date_start: '',
      date_end: '',
      error_end_date: '',
      error_start_date: '',
    }
  },
  created() {
    this.otherComponentModel.model.is_free = this.is_free
    this.otherComponentModel.model.is_import = this.is_import
    eventBus.$on('collapse-other', (text) => {
      this.otherComponentModel.collapseState = true
      this.onSubmit()
    })

    eventBus.$on('setIsOwnBrand', (val) => {
      if (val && val !== '') {
        this.onGetBrandById(val)
      }
    })
  },
  mounted() {
    this.$nextTick(() => {
      this.onSubmit()
    })
  },
  computed: {
    ...authComputed,
    userInfo() {
      if (this.getAccessToken !== null) {
        return getUserInfo(this.getAccessToken)
      } else return {}
    },
    options_vendor_type() {
      let optionsItems = this.options_type
      if (this.vendor_type == TypeEnum.OFMSTOCK) {
        return optionsItems.filter((f) => f !== 'MARKET PLACE')
      } else {
        return optionsItems.filter((f) => f == 'MARKET PLACE')
      }
    },
    options_options_aging() {
      let optionsItems = this.options_aging
      if (this.otherComponentModel.model.is_return_to_vendor) {
        return optionsItems
      } else {
        return optionsItems.filter((f) => f == '0')
      }
    },
    dataPermissions() {
      let permissions = this.permissions
      if (
        this.requestDocumentInformation !== null &&
        this.requestDocumentInformation !== undefined &&
        this.requestDocumentInformation.approval_documents !== null &&
        this.requestDocumentInformation.approval_documents !== undefined
      ) {
        let ruleEditables = this.requestDocumentInformation.approval_documents
          .filter((f) => f.my_process_action.can_edit === true)
          .map((m) => m.rule_id)

        permissions
          .filter((f) =>
            f.ruleIDs.some((s) => ruleEditables.some((r) => r === s))
          )
          .forEach((element) => {
            element.isEditable = true
          })
      } else {
        permissions.forEach((element) => {
          element.isEditable = this.is_view ? false : true
        })
      }
      return permissions
    },
  },

  watch: {
    'otherComponentModel.model.aging': {
      handler() {
        this.onSubmit()
      },
    },
    'otherComponentModel.model.type': {
      handler() {
        this.onSubmit()
      },
    },
    'otherComponentModel.model.vendor_remark': {
      handler() {
        this.onSubmit()
      },
    },
    value: {
      handler(val) {
        this.otherComponentModel = val
        if (this.otherComponentModel.model.pre_order_end_date && this.otherComponentModel.model.pre_order_end_date != "0001-01-01T00:00:00Z") {
          this.date_end = new Date(
            this.otherComponentModel.model.pre_order_end_date
          )
        }
        if (this.otherComponentModel.model.pre_order_start_date && this.otherComponentModel.model.pre_order_start_date != "0001-01-01T00:00:00Z") {
          this.date_start = new Date(
            this.otherComponentModel.model.pre_order_start_date
          )
        }
        this.$nextTick(() => {
          this.onSubmit()
        })
      },
      deep: true,
    },
    is_consignment: function (val) {
      this.setIsConsignmentByVendor(val)
    },
    vendor_type: function (val) {
      this.setDefaultTypeByVendorType(val)
    },
    'otherComponentModel.model.is_return_to_vendor': function (val) {
      this.setAgingByIsReturnToVendor(val)
    },
    is_import: function (val) {
      this.otherComponentModel.model.is_import = val
    },
    is_free: function (val) {
      this.otherComponentModel.model.is_free = val
      if (val === true) {
        this.otherComponentModel.model.is_available_stock = true
        // this.otherComponentModel.model.has_new_product_fee = true
      }
    },
    // brand_id: function(val, oldVal) {
    //   console.log('oldval', oldVal)
    //   console.log('newval', val)
    //   if (!this.isFirstLoadBand || (val && oldVal == '')) {
    //     if (val && val !== '') {
    //       this.onGetBrandById(val)
    //     }
    //     this.isFirstLoadBand = false
    //   }
    // },
    skus: {
      handler(val) {
        if (val && val.length > 0) {
          this.product_status = val[0].skuModel.product_status.inventory
          console.log('other product_status', this.product_status)
        }
      },
      deep: true,
    },
  },
  methods: {
    async onSelectDate(date, is_start_date) {
      this.error_end_date = ''
      this.error_start_date = ''
      if (date) {
        if (is_start_date) {
          this.otherComponentModel.model.pre_order_start_date =
            ToISOString(date)
        } else {
          this.error_end_date = ''
          this.otherComponentModel.model.pre_order_end_date = ToISOString(date)
        }
      } else {
        if (is_start_date) {
          this.otherComponentModel.model.pre_order_start_date = null
        } else {
          this.error_end_date = ''
          this.otherComponentModel.model.pre_order_end_date = null
        }
      }

      if (
        this.otherComponentModel.model.pre_order_start_date == null &&
        this.otherComponentModel.model.pre_order_end_date != null
      ) {
        console.log('start null')
        this.error_start_date = 'กรุณาระบุข้อมูล'
      } else if (
        this.otherComponentModel.model.pre_order_start_date != null &&
        this.otherComponentModel.model.pre_order_end_date == null
      ) {
        console.log('end null')
        this.error_end_date = 'กรุณาระบุข้อมูล'
      } else if (
        this.otherComponentModel.model.pre_order_start_date >
        this.otherComponentModel.model.pre_order_end_date
      ) {
        this.error_end_date =
          'วันเริ่มต้น Pre-Order ต้องน้อยกว่าวันสิ้นสุด Pre-Order'
      }
    },
    onClickCollapse() {
      if (this.vendor_type !== '') {
        this.otherComponentModel.collapseState =
          !this.otherComponentModel.collapseState
      } else {
        document.getElementById('header-vendor').scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        })
        eventBus.$emit('collapse-vendor', true)
      }
    },
    modelChanged() {
      this.otherComponentModel.isPayloadChanged = true
      this.$emit('input', this.otherComponentModel)
    },
    onSubmit() {
      this.$refs.componentForm.validate().then((result) => {
        console.log('onSubmit', result)
        if (
          this.otherComponentModel.model.pre_order_start_date == null &&
          this.otherComponentModel.model.pre_order_end_date != null
        ) {
          result = false
          this.error_start_date = 'กรุณาระบุข้อมูล'
        } else if (
          this.otherComponentModel.model.pre_order_start_date != null &&
          this.otherComponentModel.model.pre_order_end_date == null
        ) {
          result = false
          this.error_end_date = 'กรุณาระบุข้อมูล'
        }
        if (result) {
          this.otherComponentModel.validateState = true
        } else {
          this.otherComponentModel.validateState = false
        }
        this.modelChanged()
      })
    },
    onReset() {
      this.isReload = true
    },
    setDefaultTypeByVendorType(val) {
      if (val !== TypeEnum.OFMSTOCK) {
        this.otherComponentModel.model.type = 'MARKET PLACE'
      } else if (this.value.model.type !== '') {
        this.otherComponentModel.model.type = this.value.model.type
      } else {
        this.otherComponentModel.model.type = ''
      }
    },
    setAgingByIsReturnToVendor(val) {
      if (!val) {
        this.otherComponentModel.model.aging = '0'
      } else {
        this.otherComponentModel.model.aging = '0'
      }
    },
    setIsConsignmentByVendor(val) {
      if (val) {
        this.otherComponentModel.model.is_consignment = val
      }
    },
    async onGetBrandById(id) {
      let result = await brandService.getBrandMasterDetailAsync(id)
      if (result.status === 200) {
        this.otherComponentModel.model.is_own_brand = result.data.is_own_brand
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    addCommentClick() {
      eventBus.$emit('regist_product_comment_click', this.$options.name)
    },
  },
}
</script>
